<template>
  <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
    <div
      class="mx-auto max-w-screen-sm text-center space-y-6 flex flex-col items-center"
    >
      <h1
        class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-[#061B44]"
      >
        404
      </h1>
      <p
        class="mb-4 text-3xl tracking-tight font-bold text-[#061B44] md:text-4xl"
      >
        {{ $t("somethings-missing") }}
      </p>
      <p class="mb-4 text-lg font-semibold text-[#061B44]">
        {{
          $t(
            "sorry-we-cant-find-that-page-youll-find-lots-to-explore-on-the-home-page"
          )
        }}
      </p>
      <button
        class="cursor-pointer w-[50%] text-center bg-[#061B44] text-white text-base font-bold px-2 py-1 rounded-full"
        @click="goToHome"
      >
        {{ $t("back-to-homepage") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();

const goToHome = () => {
  router.push({ name: "Home" });
};
</script>
